import React from "react"
import { GridItem, Box, AspectRatio, Text } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"

export const ImageGridItem = ({ item }) => {
  return (
    <GridItem textAlign="center" key={item?.key} d="block" title={item?.link?.title} pos="relative" h="full">
      <Box pos="relative">
        <AspectRatio bg="grey">
          <Image pos="absolute" inset={0} w="full" h="full" objectFit="cover" objectPosition="center" {...item?.image} />
        </AspectRatio>
      </Box>
      <Text>{item.text}</Text>
    </GridItem>
  )
}
